/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolPermissionsSearch200,
  GetApiV1AccesscontrolPermissionsSearch401,
  GetApiV1AccesscontrolPermissionsSearch404,
  GetApiV1AccesscontrolPermissionsSearch500,
  GetApiV1AccesscontrolPermissionsSearchQueryParams,
  GetApiV1AccesscontrolPermissionsSearchQueryResponse,
} from "../../types/accessControlPermissionsController/GetApiV1AccesscontrolPermissionsSearch.ts";
import { userControllerPermissionViewModelSchema } from "../userControllerPermissionViewModelSchema.ts";

export const getApiV1AccesscontrolPermissionsSearchQueryParamsSchema = z
  .object({
    userName: z.optional(z.string()),
    controllerId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSearchQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolPermissionsSearch200Schema = z.lazy(
  () => userControllerPermissionViewModelSchema,
) as unknown as ToZod<GetApiV1AccesscontrolPermissionsSearch200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolPermissionsSearch401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSearch401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1AccesscontrolPermissionsSearch404Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSearch404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolPermissionsSearch500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissionsSearch500>;

export const getApiV1AccesscontrolPermissionsSearchQueryResponseSchema = z.lazy(
  () => getApiV1AccesscontrolPermissionsSearch200Schema,
) as unknown as ToZod<GetApiV1AccesscontrolPermissionsSearchQueryResponse>;
